module.exports = __webpack_public_path__ + "img/saravictoria.de6c33fd.webp";